import { render } from "./portfolioReq.vue?vue&type=template&id=3b51f92e&scoped=true"
import script from "./portfolioReq.vue?vue&type=script&lang=js"
export * from "./portfolioReq.vue?vue&type=script&lang=js"

import "./portfolioReq.vue?vue&type=style&index=0&id=3b51f92e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b51f92e"]])

export default __exports__